import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { SCHOOL_DETAILS_BY_ID } from "./apiRoutes";

export interface SchoolDetailsResponse {
  data: unknown;
}

const fetchSchoolById = async (schoolId: string) => {
  const response = await axiosAuth.get<SchoolDetailsResponse>(`${SCHOOL_DETAILS_BY_ID}${schoolId}/`);
  return response.data;
};

export const useGetSchoolByIdQuery = (
  schoolId: string,
  queryParams?: Omit<
    UseQueryOptions<SchoolDetailsResponse, Error, SchoolDetailsResponse, ["school", string]>,
    "queryKey" | "queryFn"
  >
) =>
  useQuery<SchoolDetailsResponse, Error, SchoolDetailsResponse, ["school", string]>({
    queryKey: ["school", schoolId],
    queryFn: () => fetchSchoolById(schoolId),
    enabled: !!schoolId,
    ...(queryParams || {}),
  });


